import React from "react";
import { FaSearch, FaRegWindowClose } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Button from "react-bootstrap/Button";

const CustomDatePicker = ({ dates, setDates, handlerDates }) => {

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "10px 20px",
        background: "#fff",
        width: "100%",
        borderBottom: "1px solid #eee"
      }}
    >
      <ul style={{ listStyleType: 'none' }} id='ListGroup'>
        <li className='styleUl'> - </li>
        <li className='styleUl'> - </li>

        <li style={{ float: 'right', padding: '6px', width: '80px' }}>
          <Button
            className="btn btn-primary"
            id="btnSearch"
            size="sm"
            title="Search"
            onClick={() => { handlerDates(); }}
          >
            <FaSearch title="Search" />
          </Button>

          <Button
            className="btn btn-danger"
            size="sm"
            title="Clear"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = '';
            }}
          >
            <FaRegWindowClose title="Clear" />
          </Button>

        </li>
        <li style={{ float: 'right', padding: '6px', width: '320px' }}>
          <div className="customDatePickerWidth">
            <DatePicker
              selected={dates.startDate}
              onChange={(date) => setDates({ ...dates, startDate: date })}
              selectsStart
              startDate={dates.startDate}
              endDate={dates.endDate}
              dateFormat="dd/MM/yyyy"
            />
            <DatePicker
              selected={dates.endDate}
              onChange={(date) => setDates({ ...dates, endDate: date })}
              selectsEnd
              startDate={dates.startDate}
              endDate={dates.endDate}
              minDate={dates.startDate}
              dateFormat="dd/MM/yyyy"
            />
          </div>
        </li>

      </ul>
    </div>
  );
};

export default CustomDatePicker;